<template>
  <div class="productdata">
    <div class="bar">
      <span class="btn" @click="backIndex">商品库</span>
      <span> > 产品资料</span>
    </div>
    <div class="box">
      <div class="header clearfix">
        <div class="pic">
          <img :src="companyLogo" alt="" />
        </div>
        <div class="name">{{ name }}</div>
        <div class="ckxq">
          <el-button type="text" v-if="bannerImg || information" @click="downloadAll">下载所有资料</el-button>
          <el-button type="warning" plain @click="godetial">查看详情</el-button>
        </div>
      </div>
      <div class="content">
        <div
          class="title"
          v-if="
            productClause.length > 0 ||
              healthNotification.length > 0 ||
              rateTable.length > 0 ||
              cashValue.length > 0 ||
              insuranceNotices.length > 0 ||
              productOther.length > 0 ||
              jobType.length > 0 ||
              companyIntroduce.length > 0 ||
              addedService.length > 0 ||
              bank.length > 0 ||
              mobileVisit.length > 0 ||
              securityService.length > 0 ||
              question.length > 0
          "
        >
          — 产品资料 —
        </div>
        <div class="mains">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-if="productDetail && productDetail.length > 0"
              name="1"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>产品介绍</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  target="_blank"
                  class="ora"
                  v-for="(value, i) in productDetail"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="rateTable && rateTable.length > 0" name="2">
              <template slot="title">
                <div class="mainsTitle"><i></i><span>费率表</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in rateTable"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="cashValue && cashValue.length > 0" name="3">
              <template slot="title">
                <div class="mainsTitle"><i></i><span>现金价值</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in cashValue"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="productClause && productClause.length > 0"
              name="4"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>产品条款</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  target="_blank"
                  class="ora"
                  v-for="(value, i) in productClause"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="healthNotification && healthNotification.length > 0"
              name="5"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>健康告知</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in healthNotification"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="insuranceNotices && insuranceNotices.length > 0"
              name="6"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>投保须知</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in insuranceNotices"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>

            <el-collapse-item v-if="jobType && jobType.length > 0" name="7">
              <template slot="title">
                <div class="mainsTitle"><i></i><span>职业类别</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in jobType"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="companyIntroduce && companyIntroduce.length > 0"
              name="8"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>公司介绍</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in companyIntroduce"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="addedService && addedService.length > 0"
              name="9"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>增值服务</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in addedService"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="bank && bank.length > 0" name="10">
              <template slot="title">
                <div class="mainsTitle"><i></i><span>支持银行</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in bank"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="mobileVisit && mobileVisit.length > 0"
              name="11"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>电话回访</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in mobileVisit"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item
              v-if="securityService && securityService.length > 0"
              name="12"
            >
              <template slot="title">
                <div class="mainsTitle"><i></i><span>保全服务</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in securityService"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="question && question.length > 0" name="13">
              <template slot="title">
                <div class="mainsTitle"><i></i><span>常见问题</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in question"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
            <el-collapse-item v-if="productOther && productOther.length > 0" name="14">
              <template slot="title">
                <div class="mainsTitle"><i></i><span>其他</span></div>
              </template>
              <div class="mainContent">
                <a
                  :href="value.url"
                  class="ora"
                  target="_blank"
                  v-for="(value, i) in productOther"
                  :key="i"
                  >《{{ value.val }}》
                </a>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="title" v-if="bannerImg.length > 0">
          — 产品海报 —
        </div>
        <div class="secondary">
          <!-- <div class="mainsTitle" v-if="productDetail&&productDetail.length>0"><i></i><span>产品详解</span></div>
                    <div class="contents clearfix" v-if="productDetail&&productDetail.length>0">
                        <div class="item" v-for="(value,i) in productDetail" :key="i" @click="goxj(value.url)">
                            <div class="pic">
                                <img class="se_imgs" src="@static/images/pdf.png" alt="" v-if="value.jw=='pdf'">
                                <img class="se_imgs" src="@static/images/ppt.png" alt="" v-if="value.jw=='pptx'">
                                <img class="se_imgs" src="@static/images/ppt.png" alt="" v-if="value.jw=='ppt'">
                                <img class="se_imgs" :src="value.url" alt="" v-if="value.jw=='jpg'">
                                <img class="se_imgs" :src="value.url" alt="" v-if="value.jw=='png'">
                                <img class="se_imgs" src="@static/images/word.png" alt="" v-if="value.jw=='word'">
                                <img class="se_imgs" src="@static/images/word.png" alt="" v-if="value.jw=='docx'">
                                <img class="se_imgs" src="@static/images/excel.png" alt="" v-if="value.jw=='xlsx'">
                            </div>
                            <div class="word">{{value.val}}</div>
                        </div>
                    </div> -->
          <!-- <div class="mainsTitle mar-25" v-if="bannerImg.length>0"><i></i><span>产品海报</span></div> -->
          <div class="hbcontent clearfix" v-if="bannerImg.length > 0">
            <div class="item" v-for="(item, index) in bannerImg" :key="index">
              <a :href="item.url" target="_blank">
                <img :src="item.url" alt="" />
              </a>
            </div>
          </div>
          <div v-if="!bannerImg && !information" class="null">
            <img src="@static/images/no.png" alt="" />
            <p>暂无数据</p>
          </div>
          <div class="nextAgo">
            <div class="ago" v-if="agoId" @click="ago(agoId)">
              上一篇：{{ agoName }}
            </div>
            <div class="ago next" v-if="nextId" @click="ago(nextId)">
              下一篇：{{ nextName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//当前实例组件

export default {
  data: () => ({
    activeNames: [],
    // '1','2','3','4','5'
    id: "",
    productClause: "", //产品条款
    cashValue: "", //现金价值表
    rateTable: "", //费率表
    insuranceNotices: "", //投保须知
    productOther: "", //其他
    healthNotification: "", //健康告知
    productDetail: "", //产品介绍
    jobType: "", //职业类别
    addedService: "", //增值服务
    mobileVisit: "", //电话回访
    question: "", //常见问题
    bank: "", //支持银行
    securityService: "", //保全服务
    companyIntroduce: "", //公司介绍
    bannerImg: "",
    companyLogo: "",
    name: "",
    url: "",
    agoId: "",
    nextId: "",
    nextName: "",
    agoName: "",
    ProductList: [],
    information: "",
    banner: []
  }),
  components: {},
  created() {
    this.id = this.$route.params.id;
    this.getProductList();
    this.readInformationByProductId(this.id);
  },
  methods: {
    getProductList() {
      this.$http({
        url: "/master/product/getProductList",
        type: "put",
        params: this.$tools.getLocal("ProductListParams")
      }).then((data)=> {
        if (data.data) {
          this.ProductList = data.data;
        } else {
          this.ProductList = [];
        }
        this.getnext();
      });
    },
    downloadAll() {
      window.open(
        `${this.$config.api_root}/master/product/downLoadAllProductInfo/${this.id}`
      );
    },
    backIndex() {
      this.$router.push({
        path: "/productlibrary"
      });
    },
    getnext: function() {
      for (var i = 0; i < this.ProductList.length; i++) {
        if (this.ProductList[i].id == this.id) {
          if (this.ProductList[i - 1]) {
            this.agoId = this.ProductList[i - 1].id;
            this.agoName = this.ProductList[i - 1].productName;
          } else {
            this.agoId = "";
          }
          if (this.ProductList[i + 1]) {
            this.nextId = this.ProductList[i + 1].id;
            this.nextName = this.ProductList[i + 1].productName;
          } else {
            this.nextId = "";
          }
        }
      }
    },
    ago: function(id) {
      this.id = id;
      this.$router.push({
        path: "/productdata/" + id
      });
      this.activeNames = [];
      this.getnext();
      this.readInformationByProductId(this.id);
    },
    godetial: function() {
      window.open(this.url);
    },
    goxj: function(url) {
      window.open(url);
    },
    readInformationByProductId: function(id) {
      var that = this;
      this.$http({
        url: "/master/product/readInformationByProductId",
        type: "put",
        params: {
          productId: id
        }
      }).then(function(data) {
        var value = data.data.information;
        var product = data.data.product;
        if (value) {
          that.information = value;
          if (value.productClause) {
            that.productClause = JSON.parse(value.productClause);
          } else {
            that.productClause = "";
          }
          if (value.banner) {
            that.bannerImg = JSON.parse(value.banner);
          } else {
            that.bannerImg = "";
          }
          if (value.cashValue) {
            that.cashValue = JSON.parse(value.cashValue);
          } else {
            that.cashValue = "";
          }
          if (value.rateTable) {
            that.rateTable = JSON.parse(value.rateTable);
          } else {
            that.rateTable = "";
          }
          if (value.insuranceNotices) {
            that.insuranceNotices = JSON.parse(value.insuranceNotices);
          } else {
            that.insuranceNotices = "";
          }
          if (value.productOther) {
            that.productOther = JSON.parse(value.productOther);
          } else {
            that.productOther = "";
          }
          if (value.healthNotification) {
            that.healthNotification = JSON.parse(value.healthNotification);
          } else {
            that.healthNotification = "";
          }
          if (value.productDetail) {
            var productDetail = JSON.parse(value.productDetail);
            for (var i = 0; i < productDetail.length; i++) {
              productDetail[i].jw = productDetail[i].url.split(".")[
                productDetail[i].url.split(".").length - 1
              ];
            }
            that.productDetail = productDetail;
          } else {
            that.productDetail = "";
          }
          if (value.jobType) {
            that.jobType = JSON.parse(value.jobType);
          } else {
            that.jobType = "";
          }
          if (value.addedService) {
            that.addedService = JSON.parse(value.addedService);
          } else {
            that.addedService = "";
          }
          if (value.mobileVisit) {
            that.mobileVisit = JSON.parse(value.mobileVisit);
          } else {
            that.mobileVisit = "";
          }
          if (value.question) {
            that.question = JSON.parse(value.question);
          } else {
            that.question = "";
          }
          if (value.bank) {
            that.bank = JSON.parse(value.bank);
          } else {
            that.bank = "";
          }
          if (value.securityService) {
            that.securityService = JSON.parse(value.securityService);
          } else {
            that.securityService = "";
          }
          if (value.companyIntroduce) {
            that.companyIntroduce = JSON.parse(value.companyIntroduce);
          } else {
            that.companyIntroduce = "";
          }
        } else {
          that.information = "";
          that.productClause = "";
          that.productDetail = "";
          that.healthNotification = "";
          that.productOther = "";
          that.rateTable = "";
          that.insuranceNotices = "";
          that.cashValue = "";
          that.bannerImg = "";
          that.jobType = "";
          that.addedService = "";
          that.mobileVisit = "";
          that.question = "";
          that.bank = "";
          that.securityService = "";
          that.companyIntroduce = "";
        }
        if (product) {
          that.url = product.url;
          if (product.companyLogo) {
            that.companyLogo = product.companyLogo;
          } else {
            that.companyLogo = "";
          }
          if (product.productName) {
            that.name = product.productName;
          } else {
            that.name = "";
          }
        }
      });
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
@import "~@/sass/product_m/productdata";
</style>
